(() => {
  if (window.levartiaCommerceReady) return;
  window.levartiaCommerceReady = true;
  const key = 'levartia:wishlist:v1';
  let saved = [];
  let storageWorks = true;
  const valid = (x) => x && /^\d+$/.test(String(x.id)) && /^[a-z0-9][a-z0-9-]*$/.test(x.handle) && typeof x.title === 'string';
  try {
    const raw = JSON.parse(localStorage.getItem(key) || '[]');
    saved = Array.isArray(raw) ? raw.filter(valid).slice(0, 200) : [];
  } catch { storageWorks = false; }
  const dialog = () => document.getElementById('lv-wishlist-dialog');
  const announce = (message) => { const status = document.querySelector('[data-lv-status]'); if (status) status.textContent = message; };
  const render = () => {
    document.querySelectorAll('[data-lv-wishlist]').forEach((button) => {
      const selected = saved.some(x => String(x.id) === button.dataset.productId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? button.dataset.removeLabel : button.dataset.addLabel}: ${button.dataset.title}`);
    });
    document.querySelectorAll('[data-lv-open-wishlist], [data-lv-notes]').forEach(button => { button.hidden = false; });
    const box = dialog();
    const list = box?.querySelector('[data-lv-wishlist-items]');
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) { const item = document.createElement('li'); item.textContent = box.dataset.empty; list.append(item); }
    for (const item of saved) {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.textContent = item.title;
      const root = box.dataset.root || '/';
      link.href = `${root.endsWith('/') ? root : `${root}/`}products/${encodeURIComponent(item.handle)}`;
      const remove = document.createElement('button');
      remove.type = 'button'; remove.dataset.lvRemove = item.id; remove.className = 'lv-text-link';
      remove.textContent = box.dataset.remove; remove.setAttribute('aria-label', `${box.dataset.remove}: ${item.title}`);
      row.append(link, remove); list.append(row);
    }
  };
  const commit = (message) => {
    try { localStorage.setItem(key, JSON.stringify(saved)); storageWorks = true; } catch { storageWorks = false; }
    render(); announce(storageWorks ? message : dialog()?.dataset.storageError);
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.matches('[data-lv-notes]')) {
      const card = button.closest('[data-lv-card]');
      const isOn = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(isOn));
      card.dataset.notesOpen = String(isOn);
      button.querySelector('span').textContent = isOn ? button.dataset.hide : button.dataset.show;
      button.setAttribute('aria-label', isOn ? button.dataset.hide : button.dataset.show);
    } else if (button.matches('[data-lv-wishlist]')) {
      const item = {id: button.dataset.productId, handle: button.dataset.handle, title: button.dataset.title};
      if (!valid(item)) return;
      const exists = saved.some(x => String(x.id) === item.id);
      saved = exists ? saved.filter(x => String(x.id) !== item.id) : [...saved, item].slice(-200);
      commit(exists ? dialog()?.dataset.removed : dialog()?.dataset.saved);
    } else if (button.matches('[data-lv-open-wishlist]')) { render(); dialog()?.showModal();
    } else if (button.matches('[data-lv-close]')) { button.closest('dialog')?.close();
    } else if (button.matches('[data-lv-remove]')) {
      saved = saved.filter(x => String(x.id) !== button.dataset.lvRemove); commit(dialog()?.dataset.removed);
      dialog()?.querySelector('[data-lv-close]')?.focus();
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.lv-variant-select')) return;
    const choice = event.target.selectedOptions[0];
    const quantity = event.target.form?.querySelector('[name="quantity"]');
    if (quantity) quantity.value = choice.dataset.min || '1';
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-notes-open="true"] [data-lv-notes]').forEach(b => b.click());
  });
  window.addEventListener('storage', event => {
    if (event.key !== key) return;
    try { const value = JSON.parse(event.newValue || '[]'); saved = Array.isArray(value) ? value.filter(valid).slice(0, 200) : []; render(); } catch { /* Keep the last valid state. */ }
  });
  let pending = false;
  new MutationObserver(records => {
    if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-lv-card], [data-lv-wishlist]') || n.querySelector?.('[data-lv-wishlist]'))))) return;
    if (!pending) { pending = true; queueMicrotask(() => { pending = false; render(); }); }
  }).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', render);
  render();

  if (!customElements.get('lv-parallax')) customElements.define('lv-parallax', class extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.lv-story-image img');
      this.preference = matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
      this.active = false; this.raf = null;
      this.tick = () => {
        this.raf = null;
        if (!this.media || !this.active || !this.preference.matches) return;
        const r = this.getBoundingClientRect();
        const strength = Math.max(0, Math.min(24, Number(this.dataset.strength) || 0));
        const position = Math.max(-1, Math.min(1, (innerHeight / 2 - r.top - r.height / 2) / innerHeight));
        this.media.style.setProperty('--lv-parallax-y', `${position * strength}px`);
      };
      this.schedule = () => { if (this.active && this.preference.matches && this.raf === null) this.raf = requestAnimationFrame(this.tick); };
      this.onPreference = () => { if (!this.preference.matches) this.media?.style.removeProperty('--lv-parallax-y'); this.schedule(); };
      this.observer = new IntersectionObserver(([entry]) => { this.active = entry.isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.preference.addEventListener('change', this.onPreference);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule, {passive:true});
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.preference?.removeEventListener('change', this.onPreference);
      window.removeEventListener('scroll', this.schedule); window.removeEventListener('resize', this.schedule);
      if (this.raf !== null) cancelAnimationFrame(this.raf);
    }
  });
})();
